module.exports = __webpack_public_path__ + "img/nodata3.b4a46b30.png";